// NOTE: array will be mutated (sorted) during this function
export function getTopK(array, k) {
    if (k === undefined || k <= 0) {
        return [];
    }

    // sort() will be in ascending order
    //   note: slice() is called to shallow copy the array before sorting in place
    return array.slice().sort((e1, e2) => {
        if (e1.derivedScore < e2.derivedScore) {
            return -1;
        }

        if (e1.derivedScore > e2.derivedScore) {
            return 1;
        }

        return 0;
    })
        .slice(-k)
        .reverse();
    // By slicing using a negative number on a list sorted in ascending order,
    //   we can grab the top k even if k >= list.length.
}
